import { useDispatch } from "react-redux";
import Xarrow from "react-xarrows";
import { importFromYaml } from "../../../../abstract/controller/modelYamlImport";
import { useArrowSync } from "../../../../abstract/hook/useArrowSync";
import { setRoot } from "../../../../abstract/redux/slice/structureSlice";
import ButtonIntroWide from "../../../ui/buttons/ButtonIntroWide";
import ButtonTomatoClose from "../../../ui/buttons/ButtonTomatoClose";
import styles from "./Manual.module.scss";

const id = "output3";
const idPrev = "output2";

const prev = `
functions:
  - function: simple
    parameters:
      - parameter: hero
        choices:
          - choice: Peter
          - choice: Susan
          - choice: Edmund
          - choice: Lucy
      - parameter: foe
        choices:
          - choice: witch
          - choice: cyclops
          - choice: giant
      - parameter: weapon
        choices:
          - choice: sword
          - choice: dagger
          - choice: axe
          - choice: mace
          - choice: spear
      - parameter: location
        choices:
          - choice: forest
          - choice: castle
          - choice: river
          - choice: mountain
          - choice: lake
      - output parameter: outcome
        default value: good
`;

function ManualOutput3({ tutorial, setTutorial }) {
  if (tutorial === id) {
    return <Core setTutorial={setTutorial} />;
  }

  return null;
}

function Core({ setTutorial }) {
  const _dispatch = useDispatch();
  const renderTrigger = useArrowSync();

  const handleBack = () => {
    const { model } = importFromYaml(prev);
    _dispatch(setRoot(model, 0));
    setTutorial(idPrev);
  };

  const handleClose = () => {
    setTutorial("null");
  };

  return (
    <>
      {document.getElementById("show-generator-1") && (
        <div className={`${styles["container"]} ${styles["container-out3"]} ${styles["overlay"]}`}>
          <div
            id="tutorial-text-5"
            className={`${styles["container__text"]} ${styles["container__text-1"]}`}>
            <p>Click here to generate test cases</p>
          </div>

          <Xarrow
            key={`arrow-4-${renderTrigger}`}
            start="tutorial-text-5"
            end="show-generator-1"
            color="#415B32"
            strokeWidth={3}
            path="smooth"
            curveness={0.8}
            headSize={6}
          />
        </div>
      )}

      <div className={`${styles["foreground"]} ${styles["foreground-out3"]}  ${styles["overlay"]}`}>
        <ButtonTomatoClose onClick={handleClose} />
        <div className={styles["header"]}>
          <div className={styles["header__assistant"]}></div>
          <div className={styles["header__text--main"]}>
            <p>
              Great! Now you are ready to generate the test suite. Be sure to check the output. The
              value of the <b>outcome</b> parameter should be dependent on the expression logic.
            </p>
          </div>
        </div>
        <div className={styles["confirmation"]}>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="red" title="Go back!" onClick={handleBack} />
          </div>
        </div>
      </div>
    </>
  );
}

export default ManualOutput3;
